export interface ZipCodeSuggestionsData {
	suggestionTypeCd: SuggestionTypeCd
	suggestions: Suggestion[]
}

export interface ZipCodeSuggestions {
	data: ZipCodeSuggestionsData[]
}

export interface Suggestion {
	suggestionId: string
	displayTxs: string[]
}

export enum SuggestionTypeCd {
	PRODUCTIONAREA = 'PRODUCTIONAREA',
	BROKERAGENAME = 'BRKGNM',
}
